import { isExcludedByCurrencyOrBasePairFilters, type SecurityCurrencyPair } from '@talos/kyoko';

/**
 * Currency / Base Pair matching for Market Accounts (Unified) rows.
 *
 * Derivative and spot instrument rows resolve through Security Master, same as Derivatives.
 * Cash/spot balance rows use the currency code as `Asset` (e.g. ETH), so they can match
 * Currency but cannot match Base Pair.
 */
export function isUnifiedPositionExcludedByCurrencyOrBasePairFilters(
  asset: string | undefined,
  securitiesBySymbol: Map<string, SecurityCurrencyPair>,
  currencies: string[] | undefined,
  basePairs: string[] | undefined
): boolean {
  const hasCurrencyFilter = currencies != null && currencies.length > 0;
  const hasBasePairFilter = basePairs != null && basePairs.length > 0;
  if (!hasCurrencyFilter && !hasBasePairFilter) {
    return false;
  }

  const security = asset != null ? securitiesBySymbol.get(asset) : undefined;
  if (security != null) {
    return isExcludedByCurrencyOrBasePairFilters(asset, securitiesBySymbol, currencies, basePairs);
  }

  if (hasBasePairFilter || currencies == null) {
    return true;
  }

  return asset == null || !currencies.includes(asset);
}
